import { Provider } from '@angular/core'

import { LanguageService } from '@ti/core/ui-kit/i18n'

import { FleetLanguageService } from './language.service'

export * from './language.service'

export const provideFleetLanguageService = (): Provider[] => {
  return [{ provide: LanguageService, useClass: FleetLanguageService }]
}
